// Section 11.1 - Főállású oktatók
export const NEMZETKOZI_AKKREDITACIO_OPTIONS = {
    hu: [
        { value: 'nem_vesz_reszt', label: 'A szak nem vesz részt nemzetközi akkreditációban' }
    ],
    en: [
        { value: 'nem_vesz_reszt', label: 'The programme does not participate in international accreditation' }
    ]
};

// Section 11.2 - Oktatói lefedettség
export const OKTATOI_LEFEDETTSEG_OPTIONS = {
    hu: [
        { value: 'megfelelo', label: 'Megfelelő' },
        { value: 'hatartek_kozeli', label: 'Határérték-közeli' },
        { value: 'fejlesztendo', label: 'Fejlesztendő' },
        { value: 'kritikus_kapacitashiany', label: 'Kritikus kapacitáshiány' }
    ],
    en: [
        { value: 'megfelelo', label: 'Adequate' },
        { value: 'hatartek_kozeli', label: 'Close to threshold' },
        { value: 'fejlesztendo', label: 'Requires development' },
        { value: 'kritikus_kapacitashiany', label: 'Critical capacity shortage' }
    ]
};

// Section 11.3.1 - Meghívott előadók és óraadók részvétele
export const MEGHIVOTT_ELOADOK_RESZVETEL_OPTIONS = {
    hu: [
        { value: 'rendszeres_oraadok', label: 'Rendszeres óraadók (több alkalommal, félévente)' },
        { value: 'alkalmi_vendeg', label: 'Alkalmi vendégelőadók (1-2 alkalom)' },
        { value: 'nem_volt', label: 'Nem volt meghívott előadó/óraadó' }
    ],
    en: [
        { value: 'rendszeres_oraadok', label: 'Regular adjunct instructors (multiple sessions per semester)' },
        { value: 'alkalmi_vendeg', label: 'Occasional guest lecturers (1–2 sessions)' },
        { value: 'nem_volt', label: 'No visiting lecturers or adjunct instructors' }
    ]
};

// Section 11.3.2 - Külső helyszíneken tartott órák
export const KULSO_HELYSZIN_OPTIONS = {
    hu: [
        { value: 'voltak', label: 'Voltak külső helyszínen tartott órák' },
        { value: 'nem_voltak', label: 'Nem voltak külső helyszínen tartott órák' }
    ],
    en: [
        { value: 'voltak', label: 'Classes delivered at external locations' },
        { value: 'nem_voltak', label: 'No classes delivered at external locations' }
    ]
};

// Section 11.3.3 - Vállalati/ipari üzemlátogatások
export const UZEMLATO_OPTIONS = {
    hu: [
        { value: 'voltak', label: 'Voltak üzemlátogatások' },
        { value: 'nem_voltak', label: 'Nem voltak üzemlátogatások' }
    ],
    en: [
        { value: 'voltak', label: 'Site visits conducted' },
        { value: 'nem_voltak', label: 'No site visits conducted' }
    ]
};

// Section 11.3.4 - Külföldi vendégprofesszorok részvétele
export const KULFOLDI_VENDEG_OPTIONS = {
    hu: [
        { value: 'voltak', label: 'Voltak külföldi vendégprofesszorok' },
        { value: 'nem_voltak', label: 'Nem voltak külföldi vendégprofesszorok' }
    ],
    en: [
        { value: 'voltak', label: 'International visiting professors participated' },
        { value: 'nem_voltak', label: 'No international visiting professors participated' }
    ]
};
